import { MediaFormatEnum } from '../modules/general-settings/enums/mediaFormat.enum';

const mediaAspectRatioResolutions = {
  [MediaFormatEnum.SQUARE]: '100%',
  [MediaFormatEnum.RECTANGULAR]: '160%',
};

export const getMediaAspectRatio = (mediaFormat: MediaFormatEnum) => {
  return mediaAspectRatioResolutions[mediaFormat] || '160%';
};
